<!-- 学生票二次确认弹窗 -->
<template minapp='mpx' xlang='wxml'>
  <contact-dialog
    show="{{show}}"
    title="注册成功"
    confirmText="去登录"
    bind:confirm="confirmtDialog"
    class="register-dialog"
  >
    <view class="inner-icon" slot="icon">
      <image class="inner-image"  src="{{icon}}"/>
    </view>
    <view class="inner-box">
      <view class="inner-text">账号：{{account}}</view>
      <view class="inner-text">密码：{{password}}</view>
    </view>
  </contact-dialog>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { trackEvent } from '@/common/track'
  createComponent({
    componentName: 'successDialog',
    props: {
      show: {
        type: Boolean,
        value: false
      },
      account:{
        type: String,
      },
      password:{
        type: String,
      },
      title:{
        type: String,
        value:"注册成功"
      }
    },
    data:{
      icon:"https://ut-static.udache.com/webx/sfc/WXbBwyTITi_ZQX1ZX0Y__.png"
    },
    methods: {
      confirmtDialog() {
        trackEvent('userteam_train_regpage_sucesspop_ck', 'UT-火车票-注册页面-注册成功弹窗-点击',{
          type: 'regsuc'
        })
        this.$trigger('confirm')
      }
    },
    watch: {
      show: {
        handler(val, old) {
          val && trackEvent('userteam_train_regpage_sucesspop_sw', 'UT-火车票-注册页面-注册成功弹窗-曝光',{
            type: 'regsuc'
          })
        }
      }
    },
    mounted() {
    }
  })
</script>

<style lang='stylus' scoped>
  .inner-box
    background #F6F7F8
    padding 8px
    font-size 12px 
    line-height 16px
    color #666
    margin 12px 0
    border-radius 8px
    .inner-text
      margin-top 4px
      font-family PingFangSC-Medium;
      font-size 14px
      font-weight normal
      line-height 18px
      letter-spacing 0px
      color #333333
      &:first-child
        margin-top 0
  .inner-icon
    display flex
    justify-content center
    margin-bottom 5px
    .inner-image
      width 63px
      height 67px
  .register-dialog
    /deep/ .one-btn
      margin 0 16px 24px 16px
      align-items center
    /deep/ .contact-dialog-confirm
      background #1473FF
      margin-left 0
      color #FFFFFF
      font-family PingFangSC-Medium
      font-size 16px
      font-weight normal
      line-height 19px
      text-align center
      padding-top 13px !important
      padding-bottom 16px !important
      box-sizing content-box

</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'contact-dialog': '@/pages/contact/components/contact-dialog/index'
    }
  }
</script>

